import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePaymentsStore = defineStore('payments', () => {
  const tabInfo = ref({
    name: '',
    action: null,
  })
  const paymentMethods = ref({
    topup: [],
    withdraw: [],
  })
  const paymentMethodsLoading = ref(false)

  function updateTabInfo(payload) {
    tabInfo.value = payload
  }

  function clearTabInfo() {
    tabInfo.value = { name: '', action: null }
  }

  function updatePaymentMethods(payload) {
    paymentMethods.value = {
      topup: payload?.topUp?.paymentMethods ?? [],
      withdraw: payload?.withdraw?.paymentMethods ?? [],
    }
  }

  function clearPaymentMethods() {
    paymentMethods.value = {
      topup: [],
      withdraw: [],
    }
  }

  function updatePaymentMethodsLoading(payload) {
    paymentMethodsLoading.value = payload
  }

  return {
    // refs
    tabInfo,
    paymentMethods,
    paymentMethodsLoading,
    // computed

    //functions
    updateTabInfo,
    clearTabInfo,
    updatePaymentMethods,
    clearPaymentMethods,
    updatePaymentMethodsLoading,
  }
})
